import { useState, useEffect } from "react";
import { Link } from "react-scroll";
import ReactGA from "react-ga";

export default function HeroSection() {
  const [navActive, setNavActive] = useState(false);
  const closeMenu = () => {
    setNavActive(false);
  };

  useEffect(()=>{
    // non-interaction page
    ReactGA.pageview(window.location.pathname);
  }, []);

  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <p className="section--title">Hi, I'm Preet!</p>
          <h1 className="hero--section--title">
            <span className="hero--section-title--color">Software</span>{" "}
            <br />
            Developer
          </h1>
          <p className="hero--section-description">
          Welcome! Check out my projects hub for my latest work, blog updates, and bts gallery. Let's connect - Drop me a line anytime; I'm always open to connecting and chatting about tech.👇🏽
            <br />
          </p>
        </div>
        <Link className="btn btn-primary"
                onClick={closeMenu}
                activeClass="navbar--active-content"
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                to="Contact"
        >Get In Touch</Link>
      </div>
      <div className="hero--section--img">
        <img src="./img/dp3.png" alt="Hero Section" />
      </div>
    </section>
  );
}
